import { TunaDivider as Divider } from '../primitives/divider.js'
import { Typography } from '../primitives/index.js'
import moduleStyles from './share-list.module.css'
import { graphHooks } from '@tunasong/graph-lib/react'
import type { Owned } from '@tunasong/models'
import { hasPublicAccess } from '@tunasong/models'
import type { ACL } from '@tunasong/schemas'

import type { FC } from 'react'
import { UserAvatar } from '../profile/index.js'
import ACLList from './acl-list.js'
import { ListItem, ListItemIcon, ListItemText, MenuList } from '../primitives/index.js'

export interface ShareListProps {
  className?: string
  entity?: Owned
  /** Pending users */
  pending?: string[]
  onDelete(acl: ACL): void
}

export const ShareList: FC<ShareListProps> = props => {
  const { className, pending = [], entity, onDelete } = props
  const acls: ACL[] = entity?.acls ?? []
  const { profile: ownerProfile } = graphHooks.useProfile(entity?.userId)

  if (!Array.isArray(acls)) {
    return null
  }

  const ownerEmail = ownerProfile ? ownerProfile.email : 'Loading...'

  return (
    <div className={className}>
      <MenuList>
        <ListItem>
          <ListItemIcon>
            <UserAvatar aria-label="user" userId={entity?.userId} />
          </ListItemIcon>
          <ListItemText primary={ownerEmail} secondary="Owner" />
        </ListItem>
        {hasPublicAccess(acls) && (
          <ListItem>
            <ListItemIcon>
              <UserAvatar aria-label="public" userId="PUBLIC" />
            </ListItemIcon>
            <ListItemText primary={'Public'} secondary={'READ'} />
          </ListItem>
        )}
        <Divider />
      </MenuList>
      {acls.length > 0 && (
        <Typography variant="subtitle1" className={moduleStyles.collaboratorsTitle}>
          Collaborators
        </Typography>
      )}
      <ACLList entity={entity} onDelete={onDelete} pendingPrincipals={pending} />
    </div>
  )
}

export default ShareList
